module.exports = __webpack_public_path__ + "static/po-cards-e74feb2c1a182f64add550f66ca9fc14.png";